import type { Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apiUrls from "../../../api";
import type { IContentType } from "../../../model/unityObject";
import type { RootState } from "../store";

export interface ICTState {
  list: IContentType[];
}

const initialState: ICTState = {
  list: [],
};

export const contentTypesSlice = createSlice({
  name: "contentTypes",
  initialState,
  reducers: {
    setCts: (state: ICTState, action: PayloadAction<any>) => {
      state.list = [...action.payload];
    },
  },
});

export const { setCts } = contentTypesSlice.actions;

export const fetchCts = () => (dispatch: Dispatch) => {
  axios
    .get(`${apiUrls.projects.contens.contentType}`)
    .then((res: any) => {
      const response = res.data.map((ct: IContentType) => {
        // prettify "type" values (turning "_" into "-" ) so it can match our model names
        return {
          ...ct,
          type: String(ct.type).replace(/_/g, "-"),
          infoTitle: ct.title,
          infoText: ct.description,
        };
      });
      return dispatch(setCts(response));
    })
    .catch(console.error);
};

export const getCts = (state: RootState) => state.contentTypes.list;

export const contentTypesReducer = contentTypesSlice.reducer;
